import { graphql } from '@/gql';
import type { SaveGourmetOrderMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const saveGourmetOrder = async ({
  callerId,
  storeTitle,
  storeGroup,
  estimate,
  orderOptions,
  orderId,
  preferredPhoneNumber,
  clientName,
}: SaveGourmetOrderMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      callerId,
      storeTitle,
      storeGroup,
      estimate,
      orderOptions,
      orderId,
      preferredPhoneNumber,
      clientName,
    },
    mutation: graphql(`
      mutation SaveGourmetOrder(
        $callerId: String!
        $storeTitle: String!
        $storeGroup: StoreGroupInput!
        $estimate: EstimateInput!
        $orderOptions: OrderOptionsInput!
        $orderId: String
        $preferredPhoneNumber: String
        $clientName: String
      ) {
        saveOrder(
          callerId: $callerId
          storeTitle: $storeTitle
          storeGroup: $storeGroup
          estimate: $estimate
          orderOptions: $orderOptions
          orderId: $orderId
          preferredPhoneNumber: $preferredPhoneNumber
          clientName: $clientName
        ) {
          id
          preferredPhoneNumber
          clientName
          orderId
          storeOrder {
            service
            orderId
            storeGroup
            title
            subtitle
            estimate {
              items {
                item {
                  title
                  price
                }
              }
              timeEstimate {
                min
                max
              }
              address {
                formattedAddress
              }
            }
          }
        }
      }
    `),
  });

  return response.data?.saveOrder;
};
